<!--
    课程分享-课时编辑-课件列表
    作用：用于课时编辑新增课件时，展示校区学科相关的课件列表信息
    说明：版本3.0
-->
<template>
    <div class="wrapper">
      <left-select class="left" @nodeCheck="nodeCheck" @nodeClick="nodeClick"/>
      <right-table class="right" ref="rightDome" :isAllSelection="isAllSelection"/>
    </div>
</template>
<script>
import leftSelect from './components/leftSelect'
import rightTable from './components/rightTable'
export default {
  name: 'courseList',
  components: {
    leftSelect,
    rightTable
  },
  data () {
    return {
      isAllSelection: false
    }
  },
  methods: {
    // 点击当前节点
    nodeClick (val) {
      this.$refs['rightDome'].handlerNode(val)
    },
    // 获取当前节点是否选中
    nodeCheck (val, state) {
      this.isAllSelection = state
      this.$refs['rightDome'].handlerCheckNode(val, state)
    }
  }
}
</script>
<style lang="scss" scoped>
.wrapper{
  display: flex;
  height: 100%;
  padding: 30px 20px;
  box-sizing: border-box;
  overflow: hidden;
  flex: none!important;
  height: 100vh;
  .left{
    width:250px;
    flex:0 0 250px;
    padding-right: 20px;
    border-right: 1px solid #E4E7ED;
  }
  .right{
    // flex:1
    width: calc(100% - 250px);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/CourseOn/courseList/index.vue